import React from 'react';
import { 
  Dialog, DialogTitle, DialogContent, DialogActions, 
  Button, TextField, MenuItem
} from '@mui/material';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';

const BlockSchema = Yup.object().shape({
  title: Yup.string().required('Title is required'),
  content: Yup.string(),
  level: Yup.number().required('Level is required')
});

export default function BlockFormDialog({ open, block, onClose, onSubmit }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <Formik
        initialValues={{
          title: block?.title || '',
          content: block?.content || '',
          level: block?.level || 1,
        }}
        validationSchema={BlockSchema}
        onSubmit={onSubmit}
      >
        {({ isSubmitting, errors, touched }) => (
          <Form>
            <DialogTitle>
              {block ? 'Edit Content Block' : 'Add Content Block'}
            </DialogTitle>
            <DialogContent>
              <Field name="title">
                {({ field }) => (
                  <TextField
                    {...field}
                    margin="normal"
                    label="Title"
                    fullWidth
                    error={touched.title && Boolean(errors.title)}
                    helperText={touched.title && errors.title}
                  />
                )}
              </Field>
              
              <Field name="content">
                {({ field }) => (
                  <TextField
                    {...field}
                    margin="normal"
                    label="Content"
                    fullWidth
                    multiline
                    rows={6}
                    error={touched.content && Boolean(errors.content)}
                    helperText={touched.content && errors.content}
                  />
                )}
              </Field>
              
              <Field name="level">
                {({ field }) => (
                  <TextField
                    {...field}
                    select
                    margin="normal"
                    label="Level"
                    fullWidth
                    error={touched.level && Boolean(errors.level)}
                    helperText={touched.level && errors.level}
                  >
                    <MenuItem value={1}>Level 1 (Beginner)</MenuItem>
                    <MenuItem value={2}>Level 2 (Intermediate)</MenuItem>
                    <MenuItem value={3}>Level 3 (Advanced)</MenuItem>
                  </TextField>
                )}
              </Field>
            </DialogContent>
            <DialogActions>
              <Button onClick={onClose}>Cancel</Button>
              <Button type="submit" variant="contained" disabled={isSubmitting}>
                {isSubmitting ? 'Saving...' : 'Save'}
              </Button>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
}
